import { Requisition, RerequisitionType } from '@customTypes/requisition';

import './PatientDetailOrderPill.scss';

type PillDisplay = {
  text: string;
};

const PILL_CONFIG: Record<RerequisitionType, PillDisplay> = {
  [RerequisitionType.REANALYSIS]: {
    text: 'Reanalysis',
  },
  [RerequisitionType.METHYLATION_REFLEX]: {
    text: 'Methylation Reflex',
  },
  [RerequisitionType.NEW_ORDER]: {
    text: 'Additional Order',
  },
};

const PILL_CHIP_MODIFIER_CLASS: Record<RerequisitionType, string> = {
  [RerequisitionType.REANALYSIS]: 'rerequisition-chip--reanalysis',
  [RerequisitionType.METHYLATION_REFLEX]: 'rerequisition-chip--reanalysis',
  [RerequisitionType.NEW_ORDER]: 'rerequisition-chip--new-order',
};

interface PatientDetailOrderPillProps {
  requisition: Requisition;
}

export default function PatientDetailOrderPill({ requisition }: PatientDetailOrderPillProps) {
  const rerequisitionType = requisition.rerequisition_type;

  if (!rerequisitionType) {
    return null;
  }

  const pill = PILL_CONFIG[rerequisitionType];
  const chipModifierClass = PILL_CHIP_MODIFIER_CLASS[rerequisitionType];

  if (!pill || !chipModifierClass) return null;

  return (
    <div className='patient-detail-order-pill'>
      <span className={`rerequisition-chip ${chipModifierClass}`}>{pill.text}</span>
    </div>
  );
}
